export const NEWSBOARD_POST_PROFILE_HEADER_EDIT_TITLE_BTN_QA_NAME =
  'newsboardPostProfileHeaderEditTitle'
